// 鉴权 store — 当前登录用户 + token（localStorage 持久化）
// token 由 worker 代理 unified-auth 颁发，APP_SECRET 仅在服务端

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser } from '../lib/api';

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  setAuth: (user: AuthUser, token: string) => void;
  clear: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      setAuth: (user, token) => set({ user, token }),
      clear: () => set({ user: null, token: null }),
      isAuthenticated: () => !!get().token,
    }),
    { name: 'kuaichuan-auth' },
  ),
);
